import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PageStyles,
  PageTitleStyles,
  PageSubtitleStyles,
  BottomButtonStyles,
  OverlayStyles,
} from './WelcomeScreen.styles';

export const WelcomeScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'WelcomeScreen',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles>
      <IonContent>
        <OverlayStyles />
        <div className="content-wrapper">
          <LogoWithAppName className="app-logo" withCaption={false} />
          <PageTitleStyles
            className="page-title"
            component="h1"
            variant="headline-large"
            align="center"
          >
            Never be bored with your
            <br />
            <PageSubtitleStyles
              variant="inherit"
              color="gradient"
              component="span"
              className="page-subtitle"
            >
              AI one-night stand
            </PageSubtitleStyles>
          </PageTitleStyles>
          <BottomButtonStyles
            size="large"
            round="md"
            onClick={handleNextStep}
            expand="full"
          >
            Get started!
          </BottomButtonStyles>
        </div>
      </IonContent>
    </PageStyles>
  );
};
